import React, { useMemo } from 'react';
import NavigationStepper, {
	NavigationStepperItemType,
} from '../../../../../Components/Stepper/NavigationStepper';
import MothersHealthSection from './MothersHealthSection';
import Monitoring from './Monitoring';
import { HealthPlanUser } from '../../../../../graphql/graphql';
import HealthPlanBabyCzechEndResult from '../HealthPlanBabyCzechEndResult';
import PatientsQuestionnaires from '../../../../Questionnaire/Components/PatientsQuestionnaires/PatientsQuestionnaires';

interface Props {
	patientId: string;
	healthPlanCode?: string | null;
	healthPlanUser: HealthPlanUser;
}

const PregnancyCard: React.FC<Props> = ({
	patientId,
	healthPlanCode,
	healthPlanUser,
}) => {
	const steps: NavigationStepperItemType[] = useMemo(() => {
		const tempSteps: NavigationStepperItemType[] = [
			{
				name: 'component.meddiBabyCzech.gynecologicalHistoryPlusLaboratoryExamination',
				key: 'mothersHealth',
				component: () => (
					<MothersHealthSection
						patientId={patientId}
						healthPlanCode={healthPlanCode}
					/>
				),
			},
			{
				name: 'component.meddiBabyCzech.mothersHealth',
				key: 'monitoring',
				component: () => <Monitoring patientId={patientId} />,
			},
		];

		if (healthPlanUser.hasEnded) {
			tempSteps.push({
				name: 'Informace o porodu',
				key: 'endResult',
				component: () => <HealthPlanBabyCzechEndResult patientId={patientId} />,
			});
		}

		return tempSteps;
	}, [healthPlanUser]);

	return (
		<NavigationStepper
			steps={steps}
			initialStepPath='monitoring'
			canSkip
			showStepNumbers
		/>
	);
};

export default PregnancyCard;
